import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Zoom,
} from "@mui/material";
import { useState } from "react";

function PayrollList() {
  const Payslips = [
    { id: 1, month: "February", from: "1/2/2024", to: "15/2/2024" },
  ];

  const [payslips, setPayslips] = useState(Payslips);
  return (
    <>
      {payslips.map((payslip) => {
        return (
          <Zoom in={true} style={{ transitionDelay: "200ms" }}>
            <Card key={payslip.id}>
              <CardContent>
                <Box display={"flex"} alignItems={"center"} columnGap={2}>
                  <Typography variant="body1">{payslip.id}</Typography>
                  <Typography variant="body1">{payslip.month}</Typography>
                  <Typography variant="body1">
                    {payslip.from} - {payslip.from}
                  </Typography>
                  <Box display={"flex"} ml={'auto'} columnGap={2}>
                    <Button variant="outlined" sx={{ borderRadius: 4 }}>
                      View Payroll
                    </Button>
                    <Button variant="outlined" sx={{ borderRadius: 4 }}>
                      View Payslips
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Zoom>
        );
      })}
    </>
  );
}

export default PayrollList;
